var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposedEndeavor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6296 16.5118L12.7193 15.9548C15.1107 14.7323 16.7407 12.2483 16.7407 9.38697C16.7407 5.31643 13.4409 2.0166 9.37037 2.0166C5.29983 2.0166 2 5.31643 2 9.38697C2 12.2483 3.63005 14.7323 6.02145 15.9548L7.11111 16.5118V21.0166H11.6296V16.5118ZM13.6296 17.7356C16.6636 16.1846 18.7407 13.0284 18.7407 9.38697C18.7407 4.21186 14.5455 0.0166016 9.37037 0.0166016C4.19526 0.0166016 0 4.21186 0 9.38697C0 13.0284 2.07709 16.1846 5.11111 17.7356V23.0166H13.6296V17.7356ZM9.37036 7.31162C8.33622 6.78955 7.04186 6.96038 6.17802 7.82411C5.10116 8.90085 5.10113 10.647 6.17801 11.7238L7.59214 10.3095C7.29644 10.0138 7.29643 9.53409 7.59215 9.23841C7.88793 8.94267 8.36753 8.94267 8.6633 9.2384L9.37036 9.94537L10.0774 9.2384C10.3732 8.94267 10.8528 8.94267 11.1486 9.23841C11.4443 9.53409 11.4443 10.0138 11.1486 10.3095L12.5627 11.7238C13.6396 10.647 13.6396 8.90085 12.5627 7.82411C11.6989 6.96038 10.4045 6.78955 9.37036 7.31162ZM5.87036 23.5166V25.5166H12.8704V23.5166H5.87036Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposedEndeavor);
export default __webpack_public_path__ + "static/media/proposed_endeavor.50da0b4af61a00191d2ace2dcaeb95d1.svg";
export { ForwardRef as ReactComponent };